import React from 'react';
import styles from './Footer.module.scss';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <p>&copy; 2025 Tous droits réservés</p>
    </footer>
  );
};

export default Footer;
